import * as React from 'react';
export const apobankSvg = React.forwardRef(function apobankSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#17427F',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'M18.9 24.73v-4.37h-2.78A4.32 4.32 0 0 1 11.64 16 4.25 4.25 0 0 1 16 11.64 4.22 4.22 0 0 1 20.36 16v8.73h4.37v-9.1c0-5.04-3.61-8.36-8.73-8.36A8.48 8.48 0 0 0 7.27 16c0 5 3.57 8.73 8.32 8.73h3.32z',
      }),
    ),
  );
});
apobankSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var apobank = {
  category: 'brand',
  colorable: false,
  name: 'apobank',
  svg: apobankSvg,
};
